// カスタムディレクティブを指定した要素が画面内に表示されたらフェードインのアニメーションを動かす
export default {
  mounted(el, binding) {

    const options = {
      threshold: 0.1, // デフォルト値
    };
    
    const threshold = options.threshold || 0.1;

    // デフォルトのアニメーション設定
    const defaultStyles = {
      initial: {
        opacity: '0.2',
        transition: 'all 1.3 ease',
      },
      animated: {
        opacity: '1',
      },
    };

    // カスタムアニメーション設定（binding.valueが指定されていれば上書き）
    const styles = binding.value || defaultStyles;

    // 初期状態を適用
    el.style.opacity = styles.initial.opacity;
    el.style.transition = styles.initial.transition;

    const observer = new IntersectionObserver( // Intersection Observer を初期化
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.opacity = styles.animated.opacity;
          observer.unobserve(el); //一度適用したら監視を解除
        }
      },
      { threshold } // 0.1 -> 要素が10%表示されたら発火
    );

    observer.observe(el);
  },
};

/*使用例
<template>
  <div>
    <!-- デフォルト設定 -->
    <div v-scroll-animation>
      デフォルトのアニメーション
    </div>

    <!-- カスタム設定 -->
    <div
      v-scroll-animation="{
        initial: { opacity: '0', transition: 'all 0.7s ease' },
        animated: { opacity: '1' }
      }"
    >
      カスタムアニメーション
    </div>
  </div>
</template>
*/
